import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import { useTranslation } from 'react-i18next';
import { ADMIN_PAGES_KEYS, NS } from '../../../../../../../i18n/constants/keys';

export const PreQualHeader = () => {
  const { t } = useTranslation(NS.adminPages);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: { xs: 'flex-start', sm: 'center' },
        justifyContent: 'space-between',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: 1.5,
        pb: 2,
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 36,
            height: 36,
            borderRadius: '10px',
            bgcolor: 'primary.50',
            color: 'primary.main',
          }}
        >
          <HelpOutlineRoundedIcon sx={{ fontSize: 20 }} />
        </Box>
        <Box>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 700, color: 'text.primary', lineHeight: 1.2 }}
          >
            {t(ADMIN_PAGES_KEYS.jobOpenings.jobPost.preQualifying.heading)}
          </Typography>
          <Typography
            variant="caption"
            sx={{ color: 'text.secondary', fontWeight: 500 }}
          >
            {t(ADMIN_PAGES_KEYS.jobOpenings.jobPost.preQualifying.subtitle)}
          </Typography>
        </Box>
      </Box>

      <Chip
        size="small"
        icon={<VisibilityRoundedIcon sx={{ fontSize: '13px !important' }} />}
        label={t(ADMIN_PAGES_KEYS.jobOpenings.jobPost.preQualifying.previewMode)}
        sx={{
          bgcolor: 'warning.50',
          color: 'warning.dark',
          border: '1px solid',
          borderColor: 'warning.200',
          fontWeight: 700,
          fontSize: '0.675rem',
          letterSpacing: 0.5,
          textTransform: 'uppercase',
          borderRadius: '8px',
        }}
      />
    </Box>
  );
};
